export default __webpack_public_path__ + "32de228eea17319654208d284e335032.svg";